import { isIconSizeToken } from "./isIconSizeToken";
import { resolveIconDimensions } from "./resolveIconDimensions";
import { type IconSize, SIZE_PIXELS } from "./sizes";

// `tokenFallback` exists because stroke art is uniformly on a 24-unit grid,
// where 24px renders it 1:1. Fill art sits on arbitrary grids, so it omits
// the fallback and resolves through `SIZE_PIXELS` instead.
export function resolveIconSquareDimension(
  size: IconSize,
  tokenFallback?: number,
): number | string {
  const dimensions = resolveIconDimensions(size);
  if (dimensions.mode !== "token") {
    return dimensions.value;
  }
  if (tokenFallback !== undefined) {
    return tokenFallback;
  }
  return isIconSizeToken(size) ? SIZE_PIXELS[size] : SIZE_PIXELS.md;
}
